import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "./components/ErrorBoundary";
import ability from "./configs/acl/ability";
import { store } from "./redux/store";
import GetConfigWhiteLabel from "./services/config";
import { AbilityContext } from "./utility/context/Can";
import { ThemeContext } from "./utility/context/ThemeColors";

// Estilos e Libs
import "@styles/react/libs/toastify/toastify.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/components/ripple-button";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";
import "./assets/scss/tailwind.css";

const LazyApp = lazy(() => import("./App"));

const config = GetConfigWhiteLabel();

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root nao encontrado em index.html");
const root = createRoot(container);

const suppressedWarnings = [
  "Support for defaultProps will be removed from function components",
];

const originalWarn = console.warn;
console.warn = (...args: unknown[]) => {
  const first = args[0];
  if (
    typeof first !== "string" ||
    !suppressedWarnings.some((entry) => first.includes(entry))
  ) {
    originalWarn(...args);
  }
};

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <Suspense>
          <AbilityContext.Provider value={ability}>
            <ThemeContext store={config}>
              <LazyApp config={config} />
              <ToastContainer newestOnTop />
            </ThemeContext>
          </AbilityContext.Provider>
        </Suspense>
      </Provider>
    </BrowserRouter>
  </ErrorBoundary>,
);
